// extracted by mini-css-extract-plugin
export default {"item":"productPages_item__n+ylu","image":"productPages_image__wlvFl","content":"productPages_content__MjtBL","actions":"productPages_actions__655i-"};